import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/hooks/useAuth";
import { countUnreadConversations } from "@/lib/messaging";

/**
 * Unified unread badge for /messages. Server-side count (participants'
 * last_read_at vs thread activity), replaces the old per-device
 * useInboxBadge + useUserUnreadMessages pair. The realtime channel in
 * useConversations invalidates this key on any message/conversation event.
 */
export const useUnreadConversations = (): number => {
  const { user } = useAuth();
  const { data } = useQuery({
    queryKey: ["unread-conversations", user?.id],
    enabled: !!user,
    staleTime: 30_000,
    refetchInterval: 120_000,
    queryFn: countUnreadConversations,
  });
  return data ?? 0;
};
